import * as types from 'store/mutation-types'

// initial state
const state = {
	almtype: '',
	almlevel:'',
	almplantype:''
}

// actions
const actions = {
  //设备报警类型
  setalmtype ({ commit}, almtype) {
    commit(types.SET_ALARM_TYPE, almtype)
  },
   //设备报警紧急度
  setalmlevel ({ commit },almlevel) {
    commit(types.SET_ALARM_LEVEL, almlevel)
  },
   //设备报警计划报警类型
  setalmplantype ({ commit}, almtype) {
    commit(types.SET_ALARM_PLAN_TYPE, almtype)
  },
}

// mutations
const mutations = {
  //设备报警类型
  [types.SET_ALARM_TYPE] (state, almtype) {
  		state.almtype=almtype
  },
  //设备报警紧急度
  [types.SET_ALARM_LEVEL] (state, almlevel) {
  		state.almlevel=almlevel
  },
  //设备报警计划报警类型
  [types.SET_ALARM_PLAN_TYPE] (state, almtype) {
  		state.almplantype=almtype
  },
}


export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarm.js